import React from 'react';
import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import { SubStoreProvider } from 'contexts/SubStoreContext';
import { EmployeeProvider } from 'contexts/EmployeeContext';
import { SubscriptionProvider } from 'contexts/SubscriptionContext';
import { AuthProvider } from 'contexts/AuthContext';

import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <AuthProvider>
        <SubStoreProvider>
          <EmployeeProvider>
            <SubscriptionProvider>
              <ScrollTop>
                <RouterProvider router={router} />
              </ScrollTop>
            </SubscriptionProvider>
          </EmployeeProvider>
        </SubStoreProvider>
      </AuthProvider>
    </ThemeCustomization>
  );
}
